import "./index.scss";

import React from "react";

const ServerError = ({ isShown }) => {
  return (
    <p className={`server-error ${isShown && "server-error--active"}`}>
      There was a problem connecting to the server. Please try again.
    </p>
  );
};

export default ServerError;
